export default __webpack_public_path__ + "static/media/integration.3b711121.png";